/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import type { TrackingServiceV2 } from '../feature-service-types';

const cloneEvent = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj)) as T;
};

export const trackEvent = (ctaUrl: string, imageAlt: string) => {
  if (typeof window === 'undefined') return;

  window.ixisEventData = window.ixisEventData || [];

  const destinationUrl = ctaUrl.startsWith('#')
    ? `${window.location.href.split('#')[0]}${ctaUrl}`
    : ctaUrl;

  const event: IxisEventData = {
    link: destinationUrl,
    imageAlt,
    featureAppId: __FEATURE_APP_NAME__,
    featureAppBaseUrl: window.location.origin,
  };
  window.ixisEventData.push(cloneEvent(event));
};

export const onClick = (serviceTracking: TrackingServiceV2, ctaUrl: string, imageAlt: string) => {
  if (serviceTracking) {
    const sanitizedUrl = serviceTracking.sanitizeUrl(ctaUrl || '');
    const eventAction = serviceTracking.evaluateLinkType(sanitizedUrl || '');
    const targetURL =
      sanitizedUrl.startsWith('#') && typeof window !== 'undefined'
        ? `${window.location.href.split('#')[0]}${sanitizedUrl}`
        : sanitizedUrl;
    const event = {
      eventInfo: {
        eventAction,
        eventName: 'pencil banner - click on banner ',
      },
      attributes: {
        componentName: 'pencil-banner',
        label: imageAlt,
        targetURL,
        clickID: '',
        elementName: 'banner link',
        value: '',
        pos: '',
        relatedElements: [],
      },
    };
    serviceTracking?.track({ event });
  }
};
